import React from 'react';

function RouteStepNavigator({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  currentStepInfo,
  onToggleSheet,
  onClose
}) {
  if (totalSteps === 0) return null;

  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="route-step-navigator">
      <div className="step-navigator-content">
        {/* Informação do passo atual */}
        <div className="step-info" onClick={onToggleSheet}>
          <div className="step-counter">
            Passo {currentStep + 1} de {totalSteps}
          </div>
          <div className="step-description">
            {currentStepInfo?.icon} {currentStepInfo?.text}
          </div>
          <div className="step-toggle-hint">
            {onToggleSheet && '⬆️ Toque para mais detalhes'}
          </div>
        </div>

        {/* Controles de navegação */}
        <div className="step-controls">
          <button
            className="step-btn prev"
            onClick={onPrevious}
            disabled={currentStep === 0}
            aria-label="Passo anterior"
          >
            ◀️
          </button>

          <div className="step-progress">
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          <button
            className="step-btn next"
            onClick={onNext}
            disabled={currentStep >= totalSteps - 1}
            aria-label="Próximo passo"
          >
            ▶️
          </button>

          {/* Botão fechar */}
          {onClose && (
            <button className="step-close-btn" onClick={onClose} aria-label="Fechar navegação">
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default RouteStepNavigator;
